
import { motion } from "framer-motion";
import { Mail } from "lucide-react";
import { brandColors as colors, usePalette } from "@/lib/palette";
import { fonts } from "@/lib/fonts";
import { fadeUp, stagger, scaleIn } from "@/lib/animations";
import Blob from "@/components/ui/Blob";
import EmailSignupForm from "@/components/ui/EmailSignupForm";

export default function NewsletterSection() {
  const theme = usePalette();

  return (
    <section
      id="newsletter"
      className="py-24 px-6 relative overflow-hidden"
      style={{ backgroundColor: theme.sectionBg2 }}
    >
      <Blob className="w-72 h-72 top-0 left-10" color={theme.blob1} />
      <Blob className="w-64 h-64 bottom-0 right-10" color={theme.blob3} />

      <div className="max-w-3xl mx-auto relative z-10 text-center">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          variants={stagger}
        >
          <motion.div
            variants={scaleIn}
            custom={0}
            className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
            style={{ backgroundColor: theme.accent }}
          >
            <Mail size={32} className="text-white" />
          </motion.div>

          <motion.h2
            variants={fadeUp}
            custom={1}
            className="text-4xl lg:text-5xl mb-4"
            style={{
              fontFamily: fonts.logo,
              fontWeight: 400,
              color: colors.navy,
            }}
          >
            Stay in the{" "}
            <span style={{ fontFamily: fonts.heading, color: theme.accent }}>
              Loop
            </span>
          </motion.h2>

          <motion.p
            variants={fadeUp}
            custom={2}
            className="mb-8 max-w-md mx-auto"
            style={{
              fontFamily: fonts.body,
              fontWeight: 500,
              color: `${colors.navy}88`,
              letterSpacing: "0.03em",
            }}
          >
            Get the latest projects, behind-the-scenes updates, and exclusive
            content delivered straight to your inbox. No spam, just good vibes.
          </motion.p>

          <motion.div
            variants={fadeUp}
            custom={3}
            className="mx-auto max-w-md"
          >
            <EmailSignupForm source="homepage-newsletter" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
